import { useDispatch } from 'react-redux';
import medal from '../../assets/icons/backOffice/sportsmedal.png';
import { formatUSD } from '../../helpers/helperFunctions';
import { H4, P2 } from '../../styles/FontStyles';
import { Button, Flexed } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../app/hooks';
import Spinner from '../../components/common/Spinner';
import { claimPackageRank } from './Ranking.actions';
import {
  PackageRankMyProgressModel,
  PackageRankSelectedRewardModel
} from './Ranking.types';

interface ClaimRewardProps {
  step: number;
  setStep: Dispatch<SetStateAction<number>>;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  selectedRank: PackageRankMyProgressModel | null;
}

export const ClaimReward = ({
  step,
  setStep,
  setIsOpen,
  selectedRank
}: ClaimRewardProps) => {
  const dispatch = useDispatch();

  const { t } = useTranslation('ranking');

  const { loadingRewards } = useAppSelector((state) => state.ranking);

  return (
    <Flexed column center>
      {loadingRewards ? (
        <Spinner />
      ) : (
        <>
          <img src={medal} style={{ width: 80 }} alt='' />
          <H4 mt='30'>
            {step === 1
              ? t('claim_reward_part.claim_your_reward')
              : t('claim_reward_part.thank_you')}
          </H4>
          <P2
            mt='20'
            color={color.colors.neutral500}
            style={{ textAlign: 'center' }}>
            {step === 1
              ? `${t('claim_reward_part.text1', {
                  selected: selectedRank?.name?.toUpperCase()
                })}`
              : `${t('claim_reward_part.text2', {
                  selected: selectedRank?.name?.toUpperCase()
                })}`}
          </P2>
          {step === 1 && (
            <>
              <P2 mt='32' mb='32' color={color.colors.neutral500}>
                {t('claim_reward_part.your_reward_is')}
              </P2>
              <div>
                {selectedRank?.rewards?.map(
                  (reward: PackageRankSelectedRewardModel, index: number) => (
                    <P2 bold key={index}>
                      {reward.reward.proAmount
                        ? `${formatUSD(reward.reward.proAmount)} USDT`
                        : reward.reward.name}
                    </P2>
                  )
                )}
              </div>
              <Button
                w='200px'
                h='50px'
                mt='32'
                onClick={() => {
                  dispatch(claimPackageRank({ selectedRank, setStep }));
                }}>
                {t('claim_reward_part.claim')}
              </Button>
            </>
          )}

          {step === 2 && (
            <P2
              mt='32'
              color={color.colors.primary900}
              onClick={() => setIsOpen(false)}
              style={{ cursor: 'pointer', textDecoration: 'underline' }}>
              {t('claim_reward_part.check_your_goals')}
            </P2>
          )}
        </>
      )}
    </Flexed>
  );
};
